import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Loader, useAuth0 } from '@livingsecurity/shared';
import { isSteppedUp } from '../../utils/authUtils';

const ExitStepUp = () => {
  const history = useHistory();
  const { user } = useAuth0();

  useEffect(() => {
    const exitStepUp = () => {
      if (!isSteppedUp(user)) {
        localStorage.removeItem('STEPPED_UP');
        console.log("User is not in step-up state, clearing STEPPED_UP flag and redirecting to home");
        history.push('/');
        return;
      }

      console.warn("User is still in step-up state");
      history.push('/');
    };

    exitStepUp();
  }, [history, user]);

  return <Loader />;
};

export default ExitStepUp;
